export enum DeploymentStrategies {
  PROVIDER_FIRST = 'PROVIDER_FIRST',
  CONSUMER_FIRST = 'CONSUMER_FIRST',
}
